// This is an automatically generated file! Do not edit!
// Edit the source at: https://docs.google.com/spreadsheets/d/1xjwCSOHF8OFJDYqdW71V0TFI321Bof-7J4-zaJg_skY/pubhtml
// Generated by Gruntfile.js:preloadSpreadsheet
// key: v0.7.1
'use strict';

try {
  angular.module('swarmSpreadsheetPreload');
  //console.log('secondv0.7.1');
}
catch (e) {
  // module not yet initialized by some other module, we're the first
  angular.module('swarmSpreadsheetPreload', []);
  //console.log('firstv0.7.1');
}
angular.module('swarmSpreadsheetPreload').value('spreadsheetPreload-v0.7.1', {
  "achievements": {
    "column_names": [
      "name",
      "label",
      "description",
      "longdesc",
      "requires.event",
      "requires.unittype",
      "requires.upgradetype",
      "requires.val",
      "points",
      "visible.unittype",
      "visible.upgradetype",
      "visible.val"
    ],
    "elements": [
      {
        "description": "Train your first mechanic",
        "label": "A good start",
        "longdesc": "",
        "name": "tech1_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech1",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "technology",
        "visible.upgradetype": "",
        "visible.val": "0.00E+00"
      },
      {
        "description": "Train $REQUIRED mechanics",
        "label": "Supply limit exceeded",
        "longdesc": "mechanics trained from supervisors don't count.",
        "name": "tech1_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech1",
        "requires.upgradetype": "",
        "requires.val": "2.00E+03",
        "visible.unittype": "tech1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED mechanics",
        "label": "Newsboy ready",
        "longdesc": "mechanics trained from supervisors don't count.",
        "name": "tech1_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech1",
        "requires.upgradetype": "",
        "requires.val": "1.00E+05",
        "visible.unittype": "tech1",
        "visible.upgradetype": "",
        "visible.val": "2.00E+03"
      },
      {
        "description": "Train your first supervisor",
        "label": "Supervisor",
        "longdesc": "",
        "name": "tech2_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech2",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+05"
      },
      {
        "description": "Train $REQUIRED supervisors",
        "label": "Assistant manager",
        "longdesc": "supervisors trained from brigades don't count.",
        "name": "tech2_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech2",
        "requires.upgradetype": "",
        "requires.val": "1.00E+04",
        "visible.unittype": "tech2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED supervisors",
        "label": "Manager",
        "longdesc": "supervisors trained from brigades don't count.",
        "name": "tech2_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech2",
        "requires.upgradetype": "",
        "requires.val": "1.00E+07",
        "visible.unittype": "tech2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+04"
      },
      {
        "description": "Train your first brigade",
        "label": "Brigade",
        "longdesc": "",
        "name": "tech3_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech3",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+07"
      },
      {
        "description": "Train $REQUIRED brigades",
        "label": "Comunity",
        "longdesc": "brigades trained from technology facilities don't count.",
        "name": "tech3_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech3",
        "requires.upgradetype": "",
        "requires.val": "1.00E+05",
        "visible.unittype": "tech3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED brigades",
        "label": "Society",
        "longdesc": "brigades trained from technology facilities don't count.",
        "name": "tech3_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech3",
        "requires.upgradetype": "",
        "requires.val": "1.00E+09",
        "visible.unittype": "tech3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+05"
      },
      {
        "description": "Train your first technology facility",
        "label": "Assistant",
        "longdesc": "",
        "name": "tech4_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech4",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+09"
      },
      {
        "description": "Train $REQUIRED technology facilities",
        "label": "Professor",
        "longdesc": "technology facilities trained from technology centers don't count.",
        "name": "tech4_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech4",
        "requires.upgradetype": "",
        "requires.val": "1.00E+06",
        "visible.unittype": "tech4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED technology facilities",
        "label": "Doctor",
        "longdesc": "technology facilities trained from technology centers don't count.",
        "name": "tech4_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech4",
        "requires.upgradetype": "",
        "requires.val": "1.00E+11",
        "visible.unittype": "tech4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+06"
      },
      {
        "description": "Train your first technology center",
        "label": "Researcher",
        "longdesc": "",
        "name": "tech5_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech5",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+11"
      },
      {
        "description": "Train $REQUIRED technology centers",
        "label": "Centroid",
        "longdesc": "technology centers trained from technology campuses don't count.",
        "name": "tech5_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech5",
        "requires.upgradetype": "",
        "requires.val": "1.00E+07",
        "visible.unittype": "tech5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED technology centers",
        "label": "Centrest",
        "longdesc": "technology centers trained from technology campuses don't count.",
        "name": "tech5_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech5",
        "requires.upgradetype": "",
        "requires.val": "1.00E+13",
        "visible.unittype": "tech5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+07"
      },
      {
        "description": "Train your first technology campus",
        "label": "Campus",
        "longdesc": "",
        "name": "tech6_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+13"
      },
      {
        "description": "Train $REQUIRED technology campuses",
        "label": "City",
        "longdesc": "technology campuses trained from technology complexes don't count.",
        "name": "tech6_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "1.00E+08",
        "visible.unittype": "tech6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED technology campuses",
        "label": "Country",
        "longdesc": "technology campuses trained from technology complexes don't count.",
        "name": "tech6_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "1.00E+15",
        "visible.unittype": "tech6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+08"
      },
      {
        "description": "Train your first technology complex",
        "label": "Complexing",
        "longdesc": "",
        "name": "tech7_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech7",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+15"
      },
      {
        "description": "Train $REQUIRED technology complexes",
        "label": "Complexes",
        "longdesc": "technology complexes trained from technology clusters don't count.",
        "name": "tech7_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech7",
        "requires.upgradetype": "",
        "requires.val": "1.00E+09",
        "visible.unittype": "tech7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED technology complexes",
        "label": "Complesfull",
        "longdesc": "technology complexes trained from technology clusters don't count.",
        "name": "tech7_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech7",
        "requires.upgradetype": "",
        "requires.val": "1.00E+17",
        "visible.unittype": "tech7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+09"
      },
      {
        "description": "Train your first technology cluster",
        "label": "Cluster",
        "longdesc": "",
        "name": "tech8_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech8",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+17"
      },
      {
        "description": "Train $REQUIRED technology clusters",
        "label": "Clustering",
        "longdesc": "technology clusters trained from technology neurons don't count.",
        "name": "tech8_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech8",
        "requires.upgradetype": "",
        "requires.val": "1.00E+10",
        "visible.unittype": "tech8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED technology clusters",
        "label": "Clusterest",
        "longdesc": "technology clusters trained from technology neurons don't count.",
        "name": "tech8_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech8",
        "requires.upgradetype": "",
        "requires.val": "1.00E+19",
        "visible.unittype": "tech8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+10"
      },
      {
        "description": "Train your first technology neuron",
        "label": "Single cell",
        "longdesc": "",
        "name": "tech9_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech9",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+19"
      },
      {
        "description": "Train $REQUIRED technology neurons",
        "label": "Organism",
        "longdesc": "technology neurons trained from neuron networks don't count.",
        "name": "tech9_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech9",
        "requires.upgradetype": "",
        "requires.val": "1.00E+11",
        "visible.unittype": "tech9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED technology neurons",
        "label": "Mega organism",
        "longdesc": "technology neurons trained from neuron networks don't count.",
        "name": "tech9_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech9",
        "requires.upgradetype": "",
        "requires.val": "1.00E+21",
        "visible.unittype": "tech9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+11"
      },
      {
        "description": "Train your first neuron network",
        "label": "Brain",
        "longdesc": "",
        "name": "tech10_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech10",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+21"
      },
      {
        "description": "Train $REQUIRED neuron networks",
        "label": "Snail brain",
        "longdesc": "neuron networks trained from artificial intelligences don't count.",
        "name": "tech10_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech10",
        "requires.upgradetype": "",
        "requires.val": "1.00E+12",
        "visible.unittype": "tech10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED neuron networks",
        "label": "Human brain",
        "longdesc": "neuron networks trained from artificial intelligences don't count.",
        "name": "tech10_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech10",
        "requires.upgradetype": "",
        "requires.val": "1.00E+23",
        "visible.unittype": "tech10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+12"
      },
      {
        "description": "Train your first artificial intelligence",
        "label": "Intelligence",
        "longdesc": "",
        "name": "tech11_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech11",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+23"
      },
      {
        "description": "Train $REQUIRED artificial intelligences",
        "label": "Dominatrix",
        "longdesc": "artificial intelligences trained from artificial colonies don't count.",
        "name": "tech11_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech11",
        "requires.upgradetype": "",
        "requires.val": "1.00E+13",
        "visible.unittype": "tech11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED artificial intelligences",
        "label": "World domination",
        "longdesc": "artificial intelligences trained from artificial colonies don't count.",
        "name": "tech11_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech11",
        "requires.upgradetype": "",
        "requires.val": "1.00E+25",
        "visible.unittype": "tech11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+13"
      },
      {
        "description": "Train your first artificial colony",
        "label": "Hungry colonist",
        "longdesc": "",
        "name": "tech12_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+25"
      },
      {
        "description": "Train $REQUIRED artificial colonies",
        "label": "Satisfied colonist",
        "longdesc": "artificial colonies trained from artificial civilizations don't count.",
        "name": "tech12_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "1.00E+14",
        "visible.unittype": "tech12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED artificial colonies",
        "label": "Abundant colonist",
        "longdesc": "artificial colonies trained from artificial civilizations don't count.",
        "name": "tech12_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "1.00E+27",
        "visible.unittype": "tech12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+14"
      },
      {
        "description": "Train your first artificial civilization",
        "label": "Civilizational",
        "longdesc": "",
        "name": "tech13_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "tech13",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "tech12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+27"
      },
      {
        "description": "Train $REQUIRED artificial civilizations",
        "label": "Great expansion",
        "longdesc": "",
        "name": "tech13_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "tech13",
        "requires.upgradetype": "",
        "requires.val": "1.00E+15",
        "visible.unittype": "tech13",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Train $REQUIRED artificial civilizations",
        "label": "True civilizationist",
        "longdesc": "",
        "name": "tech13_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "tech13",
        "requires.upgradetype": "",
        "requires.val": "1.00E+29",
        "visible.unittype": "tech13",
        "visible.upgradetype": "",
        "visible.val": "1.00E+15"
      },
      {
        "description": "Upgrade Junkmobile to $REQUIRED level",
        "label": "Super Junkmobile",
        "longdesc": "",
        "name": "car1_upgrade1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car1_upgrade",
        "requires.val": "1.00E+00",
        "visible.unittype": "car1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Junkmobile to $REQUIRED level",
        "label": "Perfect Junkmobile",
        "longdesc": "",
        "name": "car1_upgrade2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car1_upgrade",
        "requires.val": "1.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car1_upgrade",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Junkmobile to $REQUIRED level",
        "label": "Ultra Junkmobile",
        "longdesc": "",
        "name": "car1_upgrade3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car1_upgrade",
        "requires.val": "2.00E+01",
        "visible.unittype": "car1",
        "visible.upgradetype": "",
        "visible.val": "0.00E+00"
      },
      {
        "description": "Buy Orel Corsan",
        "label": "Buy Orel Corsan",
        "longdesc": "",
        "name": "car2_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car2_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Orel Corsan to $REQUIRED level",
        "label": "Super Orel Corsan",
        "longdesc": "",
        "name": "car2_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car2_upgrade",
        "requires.val": "1.50E+01",
        "visible.unittype": "car2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Orel Corsan to $REQUIRED level",
        "label": "Perfect Orel Corsan",
        "longdesc": "",
        "name": "car2_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car2_upgrade",
        "requires.val": "3.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car2_upgrade",
        "visible.val": "1.50E+01"
      },
      {
        "description": "Buy Frod Exort",
        "label": "Buy Frod Exort",
        "longdesc": "",
        "name": "car3_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car3_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Frod Exort to $REQUIRED level",
        "label": "Super Frod Exort",
        "longdesc": "",
        "name": "car3_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car3_upgrade",
        "requires.val": "2.00E+01",
        "visible.unittype": "car3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Frod Exort to $REQUIRED level",
        "label": "Perfect Frod Exort",
        "longdesc": "",
        "name": "car3_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car3_upgrade",
        "requires.val": "4.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car3_upgrade",
        "visible.val": "2.00E+01"
      },
      {
        "description": "Buy VW Volf",
        "label": "Buy VW Volf",
        "longdesc": "",
        "name": "car4_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car4_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade VW Volf to $REQUIRED level",
        "label": "Super VW Volf",
        "longdesc": "",
        "name": "car4_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car4_upgrade",
        "requires.val": "2.50E+01",
        "visible.unittype": "car4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade VW Volf to $REQUIRED level",
        "label": "Perfect VW Volf",
        "longdesc": "",
        "name": "car4_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car4_upgrade",
        "requires.val": "5.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car4_upgrade",
        "visible.val": "2.50E+01"
      },
      {
        "description": "Buy Hord Mocus",
        "label": "Buy Hord Mocus",
        "longdesc": "",
        "name": "car5_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car5_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Hord Mocus to $REQUIRED level",
        "label": "Super Hord Mocus",
        "longdesc": "",
        "name": "car5_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car5_upgrade",
        "requires.val": "3.00E+01",
        "visible.unittype": "car5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Hord Mocus to $REQUIRED level",
        "label": "Perfect Hord Mocus",
        "longdesc": "",
        "name": "car5_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car5_upgrade",
        "requires.val": "6.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car5_upgrade",
        "visible.val": "3.00E+01"
      },
      {
        "description": "Buy Godge Discharger",
        "label": "Buy Godge Discharger",
        "longdesc": "",
        "name": "car6_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car6_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Godge Discharger to $REQUIRED level",
        "label": "Super Godge Discharger",
        "longdesc": "",
        "name": "car6_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car6_upgrade",
        "requires.val": "3.50E+01",
        "visible.unittype": "car6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Godge Discharger to $REQUIRED level",
        "label": "Perfect Godge Discharger",
        "longdesc": "",
        "name": "car6_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car6_upgrade",
        "requires.val": "7.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car6_upgrade",
        "visible.val": "3.50E+01"
      },
      {
        "description": "Buy Linnen 366X",
        "label": "Buy Linnen 366X",
        "longdesc": "",
        "name": "car7_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car7_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Linnen 366X to $REQUIRED level",
        "label": "Super Linnen 366X",
        "longdesc": "",
        "name": "car7_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car7_upgrade",
        "requires.val": "4.00E+01",
        "visible.unittype": "car7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Linnen 366X to $REQUIRED level",
        "label": "Perfect Linnen 366X",
        "longdesc": "",
        "name": "car7_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car7_upgrade",
        "requires.val": "8.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car7_upgrade",
        "visible.val": "4.00E+01"
      },
      {
        "description": "Buy MBW 3M",
        "label": "Buy MBW 3M",
        "longdesc": "",
        "name": "car8_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car8_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade MBW 3M to $REQUIRED level",
        "label": "Super MBW 3M",
        "longdesc": "",
        "name": "car8_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car8_upgrade",
        "requires.val": "4.50E+01",
        "visible.unittype": "car8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade MBW 3M to $REQUIRED level",
        "label": "Perfect MBW 3M",
        "longdesc": "",
        "name": "car8_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car8_upgrade",
        "requires.val": "9.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "car8_upgrade",
        "visible.val": "4.50E+01"
      },
      {
        "description": "Buy Godge Venom",
        "label": "Buy Godge Venom",
        "longdesc": "",
        "name": "car9_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car9_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Godge Venom to $REQUIRED level",
        "label": "Super Godge Venom",
        "longdesc": "",
        "name": "car9_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car9_upgrade",
        "requires.val": "5.00E+01",
        "visible.unittype": "car9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Godge Venom to $REQUIRED level",
        "label": "Perfect Godge Venom",
        "longdesc": "",
        "name": "car9_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car9_upgrade",
        "requires.val": "1.00E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car9_upgrade",
        "visible.val": "5.00E+01"
      },
      {
        "description": "Buy MBW 6M",
        "label": "Buy MBW 6M",
        "longdesc": "",
        "name": "car10_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car10_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade MBW 6M to $REQUIRED level",
        "label": "Super MBW 6M",
        "longdesc": "",
        "name": "car10_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car10_upgrade",
        "requires.val": "5.50E+01",
        "visible.unittype": "car10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade MBW 6M to $REQUIRED level",
        "label": "Perfect MBW 6M",
        "longdesc": "",
        "name": "car10_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car10_upgrade",
        "requires.val": "1.10E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car10_upgrade",
        "visible.val": "5.50E+01"
      },
      {
        "description": "Buy Rhamboginny gallileo",
        "label": "Buy Rhamboginny gallileo",
        "longdesc": "",
        "name": "car11_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car11_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Rhamboginny gallileo to $REQUIRED level",
        "label": "Super Rhamboginny gallileo",
        "longdesc": "",
        "name": "car11_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car11_upgrade",
        "requires.val": "6.00E+01",
        "visible.unittype": "car11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Rhamboginny gallileo to $REQUIRED level",
        "label": "Perfect Rhamboginny gallileo",
        "longdesc": "",
        "name": "car11_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car11_upgrade",
        "requires.val": "1.20E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car11_upgrade",
        "visible.val": "6.00E+01"
      },
      {
        "description": "Buy Racho 112 g3t",
        "label": "Buy Racho 112 g3t",
        "longdesc": "",
        "name": "car12_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car12_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Racho 112 g3t to $REQUIRED level",
        "label": "Super Racho 112 g3t",
        "longdesc": "",
        "name": "car12_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car12_upgrade",
        "requires.val": "6.50E+01",
        "visible.unittype": "car12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Racho 112 g3t to $REQUIRED level",
        "label": "Perfect Racho 112 g3t",
        "longdesc": "",
        "name": "car12_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car12_upgrade",
        "requires.val": "1.30E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car12_upgrade",
        "visible.val": "6.50E+01"
      },
      {
        "description": "Buy 1f∞",
        "label": "Buy 1f∞",
        "longdesc": "",
        "name": "car13_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car13_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade 1f∞ to $REQUIRED level",
        "label": "Super 1f∞",
        "longdesc": "",
        "name": "car13_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car13_upgrade",
        "requires.val": "7.00E+01",
        "visible.unittype": "car13",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade 1f∞ to $REQUIRED level",
        "label": "Perfect 1f∞",
        "longdesc": "",
        "name": "car13_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car13_upgrade",
        "requires.val": "1.40E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car13_upgrade",
        "visible.val": "7.00E+01"
      },
      {
        "description": "Buy Alon Missin BD9",
        "label": "Buy Alon Missin BD9",
        "longdesc": "",
        "name": "car14_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car14_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car13",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Alon Missin BD9 to $REQUIRED level",
        "label": "Super Alon Missin BD9",
        "longdesc": "",
        "name": "car14_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car14_upgrade",
        "requires.val": "7.50E+01",
        "visible.unittype": "car14",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Alon Missin BD9 to $REQUIRED level",
        "label": "Perfect Alon Missin BD9",
        "longdesc": "",
        "name": "car14_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car14_upgrade",
        "requires.val": "1.50E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car14_upgrade",
        "visible.val": "7.50E+01"
      },
      {
        "description": "Buy Berkley Island GTI",
        "label": "Buy Berkley Island GTI",
        "longdesc": "",
        "name": "car15_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car15_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car14",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Berkley Island GTI to $REQUIRED level",
        "label": "Super Berkley Island GTI",
        "longdesc": "",
        "name": "car15_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car15_upgrade",
        "requires.val": "8.00E+01",
        "visible.unittype": "car15",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Berkley Island GTI to $REQUIRED level",
        "label": "Perfect Berkley Island GTI",
        "longdesc": "",
        "name": "car15_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car15_upgrade",
        "requires.val": "1.60E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car15_upgrade",
        "visible.val": "8.00E+01"
      },
      {
        "description": "Buy ☮ SSS GMA",
        "label": "Buy ☮ SSS GMA",
        "longdesc": "",
        "name": "car16_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car16_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car15",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade ☮ SSS GMA to $REQUIRED level",
        "label": "Super ☮ SSS GMA",
        "longdesc": "",
        "name": "car16_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car16_upgrade",
        "requires.val": "8.50E+01",
        "visible.unittype": "car16",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade ☮ SSS GMA to $REQUIRED level",
        "label": "Perfect ☮ SSS GMA",
        "longdesc": "",
        "name": "car16_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car16_upgrade",
        "requires.val": "1.70E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car16_upgrade",
        "visible.val": "8.50E+01"
      },
      {
        "description": "Buy Sani RGT",
        "label": "Buy Sani RGT",
        "longdesc": "",
        "name": "car17_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car17_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car16",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sani RGT to $REQUIRED level",
        "label": "Super Sani RGT",
        "longdesc": "",
        "name": "car17_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car17_upgrade",
        "requires.val": "9.00E+01",
        "visible.unittype": "car17",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sani RGT to $REQUIRED level",
        "label": "Perfect Sani RGT",
        "longdesc": "",
        "name": "car17_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car17_upgrade",
        "requires.val": "1.80E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car17_upgrade",
        "visible.val": "9.00E+01"
      },
      {
        "description": "Buy Biellari F&F",
        "label": "Buy Biellari F&F",
        "longdesc": "",
        "name": "car18_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car18_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car17",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Biellari F&F to $REQUIRED level",
        "label": "Super Biellari F&F",
        "longdesc": "",
        "name": "car18_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car18_upgrade",
        "requires.val": "9.50E+01",
        "visible.unittype": "car18",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Biellari F&F to $REQUIRED level",
        "label": "Perfect Biellari F&F",
        "longdesc": "",
        "name": "car18_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car18_upgrade",
        "requires.val": "1.90E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car18_upgrade",
        "visible.val": "9.50E+01"
      },
      {
        "description": "Buy Rhamboginny Coriodor",
        "label": "Buy Rhamboginny Coriodor",
        "longdesc": "",
        "name": "car19_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car19_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car18",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Rhamboginny Coriodor to $REQUIRED level",
        "label": "Super Rhamboginny Coriodor",
        "longdesc": "",
        "name": "car19_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car19_upgrade",
        "requires.val": "1.00E+02",
        "visible.unittype": "car19",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Rhamboginny Coriodor to $REQUIRED level",
        "label": "Perfect Rhamboginny Coriodor",
        "longdesc": "",
        "name": "car19_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car19_upgrade",
        "requires.val": "2.00E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car19_upgrade",
        "visible.val": "1.00E+02"
      },
      {
        "description": "Buy Biellari 358",
        "label": "Buy Biellari 358",
        "longdesc": "",
        "name": "car20_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car20_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car19",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Biellari 358 to $REQUIRED level",
        "label": "Super Biellari 358",
        "longdesc": "",
        "name": "car20_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car20_upgrade",
        "requires.val": "1.05E+02",
        "visible.unittype": "car20",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Biellari 358 to $REQUIRED level",
        "label": "Perfect Biellari 358",
        "longdesc": "",
        "name": "car20_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car20_upgrade",
        "requires.val": "2.10E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car20_upgrade",
        "visible.val": "1.05E+02"
      },
      {
        "description": "Buy Sabani Londa F",
        "label": "Buy Sabani Londa F",
        "longdesc": "",
        "name": "car21_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car21_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car20",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sabani Londa F to $REQUIRED level",
        "label": "Super Sabani Londa F",
        "longdesc": "",
        "name": "car21_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car21_upgrade",
        "requires.val": "1.10E+02",
        "visible.unittype": "car21",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sabani Londa F to $REQUIRED level",
        "label": "Perfect Sabani Londa F",
        "longdesc": "",
        "name": "car21_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car21_upgrade",
        "requires.val": "2.20E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car21_upgrade",
        "visible.val": "1.10E+02"
      },
      {
        "description": "Buy McKenzee P1",
        "label": "Buy McKenzee P1",
        "longdesc": "",
        "name": "car22_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car22_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car21",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade McKenzee P1 to $REQUIRED level",
        "label": "Super McKenzee P1",
        "longdesc": "",
        "name": "car22_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car22_upgrade",
        "requires.val": "1.15E+02",
        "visible.unittype": "car22",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade McKenzee P1 to $REQUIRED level",
        "label": "Perfect McKenzee P1",
        "longdesc": "",
        "name": "car22_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car22_upgrade",
        "requires.val": "2.30E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car22_upgrade",
        "visible.val": "1.15E+02"
      },
      {
        "description": "Buy Sabani Whyhra",
        "label": "Buy Sabani Whyhra",
        "longdesc": "",
        "name": "car23_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car23_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car22",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sabani Whyhra to $REQUIRED level",
        "label": "Super Sabani Whyhra",
        "longdesc": "",
        "name": "car23_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car23_upgrade",
        "requires.val": "1.20E+02",
        "visible.unittype": "car23",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sabani Whyhra to $REQUIRED level",
        "label": "Perfect Sabani Whyhra",
        "longdesc": "",
        "name": "car23_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car23_upgrade",
        "requires.val": "2.40E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car23_upgrade",
        "visible.val": "1.20E+02"
      },
      {
        "description": "Buy Sabatt Pieron",
        "label": "Buy Sabatt Pieron",
        "longdesc": "",
        "name": "car24_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car24_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car23",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sabatt Pieron to $REQUIRED level",
        "label": "Super Sabatt Pieron",
        "longdesc": "",
        "name": "car24_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car24_upgrade",
        "requires.val": "1.25E+02",
        "visible.unittype": "car24",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Sabatt Pieron to $REQUIRED level",
        "label": "Perfect Sabatt Pieron",
        "longdesc": "",
        "name": "car24_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car24_upgrade",
        "requires.val": "2.50E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car24_upgrade",
        "visible.val": "1.25E+02"
      },
      {
        "description": "Buy Zyxwvutsrqpo RXCC",
        "label": "Buy Zyxwvutsrqpo RXCC",
        "longdesc": "",
        "name": "car25_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car25_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car24",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Zyxwvutsrqpo RXCC to $REQUIRED level",
        "label": "Super Zyxwvutsrqpo RXCC",
        "longdesc": "",
        "name": "car25_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car25_upgrade",
        "requires.val": "1.30E+02",
        "visible.unittype": "car25",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Zyxwvutsrqpo RXCC to $REQUIRED level",
        "label": "Perfect Zyxwvutsrqpo RXCC",
        "longdesc": "",
        "name": "car25_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car25_upgrade",
        "requires.val": "2.60E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car25_upgrade",
        "visible.val": "1.30E+02"
      },
      {
        "description": "Buy Zyxwvutsrqpo Adela",
        "label": "Buy Zyxwvutsrqpo Adela",
        "longdesc": "",
        "name": "car26_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car26_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car25",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Zyxwvutsrqpo Adela to $REQUIRED level",
        "label": "Super Zyxwvutsrqpo Adela",
        "longdesc": "",
        "name": "car26_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car26_upgrade",
        "requires.val": "1.35E+02",
        "visible.unittype": "car26",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Zyxwvutsrqpo Adela to $REQUIRED level",
        "label": "Perfect Zyxwvutsrqpo Adela",
        "longdesc": "",
        "name": "car26_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car26_upgrade",
        "requires.val": "2.70E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car26_upgrade",
        "visible.val": "1.35E+02"
      },
      {
        "description": "Buy Traki 7±2",
        "label": "Buy Traki 7±2",
        "longdesc": "",
        "name": "car27_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car27_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car26",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Traki 7±2 to $REQUIRED level",
        "label": "Super Traki 7±2",
        "longdesc": "",
        "name": "car27_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car27_upgrade",
        "requires.val": "1.40E+02",
        "visible.unittype": "car27",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Traki 7±2 to $REQUIRED level",
        "label": "Perfect Traki 7±2",
        "longdesc": "",
        "name": "car27_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car27_upgrade",
        "requires.val": "2.80E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car27_upgrade",
        "visible.val": "1.40E+02"
      },
      {
        "description": "Buy Puldin CC",
        "label": "Buy Puldin CC",
        "longdesc": "",
        "name": "car28_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car28_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car27",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Puldin CC to $REQUIRED level",
        "label": "Super Puldin CC",
        "longdesc": "",
        "name": "car28_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car28_upgrade",
        "requires.val": "1.45E+02",
        "visible.unittype": "car28",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Puldin CC to $REQUIRED level",
        "label": "Perfect Puldin CC",
        "longdesc": "",
        "name": "car28_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car28_upgrade",
        "requires.val": "2.90E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car28_upgrade",
        "visible.val": "1.45E+02"
      },
      {
        "description": "Buy Omurtag TX",
        "label": "Buy Omurtag TX",
        "longdesc": "",
        "name": "car29_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car29_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car28",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Omurtag TX to $REQUIRED level",
        "label": "Super Omurtag TX",
        "longdesc": "",
        "name": "car29_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car29_upgrade",
        "requires.val": "1.50E+02",
        "visible.unittype": "car29",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Omurtag TX to $REQUIRED level",
        "label": "Perfect Omurtag TX",
        "longdesc": "",
        "name": "car29_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car29_upgrade",
        "requires.val": "3.00E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car29_upgrade",
        "visible.val": "1.50E+02"
      },
      {
        "description": "Buy Tangra XR",
        "label": "Buy Tangra XR",
        "longdesc": "",
        "name": "car30_own",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car30_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car29",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Tangra XR to $REQUIRED level",
        "label": "Super Tangra XR",
        "longdesc": "",
        "name": "car30_upgrade1",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car30_upgrade",
        "requires.val": "1.55E+02",
        "visible.unittype": "car30",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade Tangra XR to $REQUIRED level",
        "label": "Perfect Tangra XR",
        "longdesc": "",
        "name": "car30_upgrade2",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "car30_upgrade",
        "requires.val": "3.10E+02",
        "visible.unittype": "",
        "visible.upgradetype": "car30_upgrade",
        "visible.val": "1.55E+02"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "Recognized",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1.00E+03",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "0.00E+00"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "Influential",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1.00E+06",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1.00E+03"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "Famous",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1.00E+12",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1.00E+06"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "Popular",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame4",
        "points": "40",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1.00E+24",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1.00E+12"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "Celebrity",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame5",
        "points": "50",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1.00E+48",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1.00E+24"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "World Recognized",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame6",
        "points": "60",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1E+96",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1.00E+48"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "World Influential",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame7",
        "points": "70",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1E+192",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1E+96"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "World Famous",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame8",
        "points": "80",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1E+384",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1E+192"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "World Popular",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame9",
        "points": "90",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1E+768",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1E+384"
      },
      {
        "description": "Earn $REQUIRED fame from races",
        "label": "World Celebrity",
        "longdesc": "Fame from racers doesn't count",
        "name": "fame10",
        "points": "100",
        "requires.event": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1E+1536",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1E+768"
      },
      {
        "description": "Buy newsboy",
        "label": "Find newsboy",
        "longdesc": "",
        "name": "sponsor1_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor1",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "fame",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED newsboys",
        "label": "newsboy Popular",
        "longdesc": "",
        "name": "sponsor1_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor1",
        "requires.upgradetype": "",
        "requires.val": "1.00E+02",
        "visible.unittype": "sponsor1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED newsboys",
        "label": "newsboy Most popular",
        "longdesc": "",
        "name": "sponsor1_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor1",
        "requires.upgradetype": "",
        "requires.val": "1.00E+05",
        "visible.unittype": "sponsor1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+02"
      },
      {
        "description": "Buy school newspaper",
        "label": "Find school newspaper",
        "longdesc": "",
        "name": "sponsor2_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor2",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+05"
      },
      {
        "description": "Buy $REQUIRED school newspapers",
        "label": "school newspaper Popular",
        "longdesc": "",
        "name": "sponsor2_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor2",
        "requires.upgradetype": "",
        "requires.val": "1.00E+03",
        "visible.unittype": "sponsor2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED school newspapers",
        "label": "school newspaper Most popular",
        "longdesc": "",
        "name": "sponsor2_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor2",
        "requires.upgradetype": "",
        "requires.val": "1.00E+07",
        "visible.unittype": "sponsor2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+03"
      },
      {
        "description": "Buy village newspaper",
        "label": "Find village newspaper",
        "longdesc": "",
        "name": "sponsor3_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor3",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor2",
        "visible.upgradetype": "",
        "visible.val": "1.00E+07"
      },
      {
        "description": "Buy $REQUIRED village newspapers",
        "label": "village newspaper Popular",
        "longdesc": "",
        "name": "sponsor3_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor3",
        "requires.upgradetype": "",
        "requires.val": "1.00E+04",
        "visible.unittype": "sponsor3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED village newspapers",
        "label": "village newspaper Most popular",
        "longdesc": "",
        "name": "sponsor3_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor3",
        "requires.upgradetype": "",
        "requires.val": "1.00E+09",
        "visible.unittype": "sponsor3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+04"
      },
      {
        "description": "Buy city newspaper",
        "label": "Find city newspaper",
        "longdesc": "",
        "name": "sponsor4_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor4",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor3",
        "visible.upgradetype": "",
        "visible.val": "1.00E+09"
      },
      {
        "description": "Buy $REQUIRED city newspapers",
        "label": "city newspaper Popular",
        "longdesc": "",
        "name": "sponsor4_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor4",
        "requires.upgradetype": "",
        "requires.val": "1.00E+05",
        "visible.unittype": "sponsor4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED city newspapers",
        "label": "city newspaper Most popular",
        "longdesc": "",
        "name": "sponsor4_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor4",
        "requires.upgradetype": "",
        "requires.val": "1.00E+11",
        "visible.unittype": "sponsor4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+05"
      },
      {
        "description": "Buy newspaper",
        "label": "Find newspaper",
        "longdesc": "",
        "name": "sponsor5_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor5",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+11"
      },
      {
        "description": "Buy $REQUIRED newspapers",
        "label": "newspaper Popular",
        "longdesc": "",
        "name": "sponsor5_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor5",
        "requires.upgradetype": "",
        "requires.val": "1.00E+06",
        "visible.unittype": "sponsor5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED newspapers",
        "label": "newspaper Most popular",
        "longdesc": "",
        "name": "sponsor5_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor5",
        "requires.upgradetype": "",
        "requires.val": "1.00E+13",
        "visible.unittype": "sponsor5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+06"
      },
      {
        "description": "Buy local magazine",
        "label": "Find local magazine",
        "longdesc": "",
        "name": "sponsor6_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor6",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor5",
        "visible.upgradetype": "",
        "visible.val": "1.00E+13"
      },
      {
        "description": "Buy $REQUIRED local magazines",
        "label": "local magazine Popular",
        "longdesc": "",
        "name": "sponsor6_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor6",
        "requires.upgradetype": "",
        "requires.val": "1.00E+07",
        "visible.unittype": "sponsor6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED local magazines",
        "label": "local magazine Most popular",
        "longdesc": "",
        "name": "sponsor6_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor6",
        "requires.upgradetype": "",
        "requires.val": "1.00E+15",
        "visible.unittype": "sponsor6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+07"
      },
      {
        "description": "Buy magazine",
        "label": "Find magazine",
        "longdesc": "",
        "name": "sponsor7_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor7",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor6",
        "visible.upgradetype": "",
        "visible.val": "1.00E+15"
      },
      {
        "description": "Buy $REQUIRED magazines",
        "label": "magazine Popular",
        "longdesc": "",
        "name": "sponsor7_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor7",
        "requires.upgradetype": "",
        "requires.val": "1.00E+08",
        "visible.unittype": "sponsor7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED magazines",
        "label": "magazine Most popular",
        "longdesc": "",
        "name": "sponsor7_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor7",
        "requires.upgradetype": "",
        "requires.val": "1.00E+17",
        "visible.unittype": "sponsor7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+08"
      },
      {
        "description": "Buy international magazine",
        "label": "Find international magazine",
        "longdesc": "",
        "name": "sponsor8_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor8",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor7",
        "visible.upgradetype": "",
        "visible.val": "1.00E+17"
      },
      {
        "description": "Buy $REQUIRED international magazines",
        "label": "international magazine Popular",
        "longdesc": "",
        "name": "sponsor8_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor8",
        "requires.upgradetype": "",
        "requires.val": "1.00E+09",
        "visible.unittype": "sponsor8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED international magazines",
        "label": "international magazine Most popular",
        "longdesc": "",
        "name": "sponsor8_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor8",
        "requires.upgradetype": "",
        "requires.val": "1.00E+19",
        "visible.unittype": "sponsor8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+09"
      },
      {
        "description": "Buy radio station",
        "label": "Find radio station",
        "longdesc": "",
        "name": "sponsor9_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor9",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor8",
        "visible.upgradetype": "",
        "visible.val": "1.00E+19"
      },
      {
        "description": "Buy $REQUIRED radio stations",
        "label": "radio station Popular",
        "longdesc": "",
        "name": "sponsor9_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor9",
        "requires.upgradetype": "",
        "requires.val": "1.00E+10",
        "visible.unittype": "sponsor9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED radio stations",
        "label": "radio station Most popular",
        "longdesc": "",
        "name": "sponsor9_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor9",
        "requires.upgradetype": "",
        "requires.val": "1.00E+21",
        "visible.unittype": "sponsor9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+10"
      },
      {
        "description": "Buy radio network",
        "label": "Find radio network",
        "longdesc": "",
        "name": "sponsor10_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor10",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor9",
        "visible.upgradetype": "",
        "visible.val": "1.00E+21"
      },
      {
        "description": "Buy $REQUIRED radio networks",
        "label": "radio network Popular",
        "longdesc": "",
        "name": "sponsor10_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor10",
        "requires.upgradetype": "",
        "requires.val": "1.00E+11",
        "visible.unittype": "sponsor10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED radio networks",
        "label": "radio network Most popular",
        "longdesc": "",
        "name": "sponsor10_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor10",
        "requires.upgradetype": "",
        "requires.val": "1.00E+23",
        "visible.unittype": "sponsor10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+11"
      },
      {
        "description": "Buy tv station",
        "label": "Find tv station",
        "longdesc": "",
        "name": "sponsor11_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor11",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor10",
        "visible.upgradetype": "",
        "visible.val": "1.00E+23"
      },
      {
        "description": "Buy $REQUIRED tv stations",
        "label": "tv station Popular",
        "longdesc": "",
        "name": "sponsor11_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor11",
        "requires.upgradetype": "",
        "requires.val": "1.00E+12",
        "visible.unittype": "sponsor11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED tv stations",
        "label": "tv station Most popular",
        "longdesc": "",
        "name": "sponsor11_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor11",
        "requires.upgradetype": "",
        "requires.val": "1.00E+25",
        "visible.unittype": "sponsor11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+12"
      },
      {
        "description": "Buy tv network",
        "label": "Find tv network",
        "longdesc": "",
        "name": "sponsor12_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "sponsor12",
        "requires.upgradetype": "",
        "requires.val": "1.00E+00",
        "visible.unittype": "sponsor11",
        "visible.upgradetype": "",
        "visible.val": "1.00E+25"
      },
      {
        "description": "Buy $REQUIRED tv networks",
        "label": "tv network Popular",
        "longdesc": "",
        "name": "sponsor12_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "sponsor12",
        "requires.upgradetype": "",
        "requires.val": "1.00E+13",
        "visible.unittype": "sponsor12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Buy $REQUIRED tv networks",
        "label": "tv network Most popular",
        "longdesc": "",
        "name": "sponsor12_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "sponsor12",
        "requires.upgradetype": "",
        "requires.val": "1.00E+27",
        "visible.unittype": "sponsor12",
        "visible.upgradetype": "",
        "visible.val": "1.00E+13"
      },
      {
        "description": "Hire a racer",
        "label": "Hired force",
        "longdesc": "",
        "name": "autoclicker_1",
        "points": "10",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "autoclicker_buy",
        "requires.val": "1.00E+00",
        "visible.unittype": "car4",
        "visible.upgradetype": "",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade racer to $REQUIRED level",
        "label": "Delegation",
        "longdesc": "",
        "name": "autoclicker_2",
        "points": "20",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "autoclicker_upgrade",
        "requires.val": "1.50E+01",
        "visible.unittype": "",
        "visible.upgradetype": "autoclicker_buy",
        "visible.val": "1.00E+00"
      },
      {
        "description": "Upgrade racer to $REQUIRED level",
        "label": "Divident",
        "longdesc": "",
        "name": "autoclicker_3",
        "points": "30",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "autoclicker_upgrade",
        "requires.val": "3.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "autoclicker_upgrade",
        "visible.val": "1.50E+01"
      },
      {
        "description": "Upgrade racer to $REQUIRED level",
        "label": "Corporate",
        "longdesc": "",
        "name": "autoclicker_4",
        "points": "40",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "autoclicker_upgrade",
        "requires.val": "5.00E+01",
        "visible.unittype": "",
        "visible.upgradetype": "autoclicker_upgrade",
        "visible.val": "3.00E+01"
      },
      {
        "description": "Upgrade racer to $REQUIRED level",
        "label": "Holding",
        "longdesc": "",
        "name": "autoclicker_5",
        "points": "50",
        "requires.event": "",
        "requires.unittype": "",
        "requires.upgradetype": "autoclicker_upgrade",
        "requires.val": "1.00E+02",
        "visible.unittype": "",
        "visible.upgradetype": "autoclicker_upgrade",
        "visible.val": "5.00E+01"
      },
      {
        "description": "Train more artificial colonies than the galaxies in the observable universe",
        "label": "The galaxies",
        "longdesc": "only manually trained artificial colonies are counted",
        "name": "more_than_galaxies",
        "points": "50",
        "requires.event": "",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "5.00E+11",
        "visible.unittype": "tech12",
        "visible.upgradetype": "",
        "visible.val": "5.00E+11"
      },
      {
        "description": "Train more technology campuses than the stars in the observable universe",
        "label": "The stars",
        "longdesc": "only manually trained technology campuses are counted",
        "name": "more_than_stars",
        "points": "75",
        "requires.event": "",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "3.00E+23",
        "visible.unittype": "tech6",
        "visible.upgradetype": "",
        "visible.val": "3.00E+23"
      },
      {
        "description": "Train more mechanics than the atoms in the observable universe",
        "label": "The atoms",
        "longdesc": "only manually trained mechanics are counted",
        "name": "more_than_atoms",
        "points": "100",
        "requires.event": "",
        "requires.unittype": "tech1",
        "requires.upgradetype": "",
        "requires.val": "1.00E+82",
        "visible.unittype": "tech1",
        "visible.upgradetype": "",
        "visible.val": "1.00E+82"
      }
    ],
    "name": "achievements"
  },
  "unittypes": {
    "column_names": [
      "name",
      "label",
      "plural",
      "short",
      "verb",
      "verbone",
      "verbing",
      "tab",
      "init",
      "description",
      "lol",
      "disabled",
      "unbuyable",
      "persist",
      "cost.unittype",
      "cost.val",
      "prod.unittype",
      "prod.val",
      "showparent",
      "warnfirst.unittype",
      "warnfirst.val",
      "warnfirst.text",
      "requires.unittype",
      "requires.upgradetype",
      "requires.val",
      "requires.op",
      "effect.type",
      "effect.unittype",
      "effect.val",
      "effect.stat",
      "effect.val2",
      "effect.unittype2",
      "effect.val3"
    ],
    "elements": [
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "fame",
        "lol": "",
        "name": "fake_fame",
        "persist": "",
        "plural": "fame",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "driving",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "fame",
        "showparent": "",
        "tab": "",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "The driving force",
        "disabled": "TRUE",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "driving",
        "lol": "Stop digging around in the source code, you dirty cheater.",
        "name": "driving",
        "persist": "",
        "plural": "drivings",
        "prod.unittype": "fake_fame",
        "prod.val": "1",
        "requires.op": "",
        "requires.unittype": "driving",
        "requires.upgradetype": "",
        "requires.val": "0",
        "short": "driving",
        "showparent": "",
        "tab": "",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Technology is essential for developing new cars and improving existing",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "15",
        "label": "technology",
        "lol": "",
        "name": "technology",
        "persist": "",
        "plural": "technology",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "car1",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "technology",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "TRUE",
        "verb": "generate",
        "verbing": "generating",
        "verbone": "generates",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Money buys almost anything.",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "1000",
        "label": "bucks",
        "lol": "",
        "name": "money",
        "persist": "",
        "plural": "bucks",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "money",
        "requires.upgradetype": "",
        "requires.val": "0",
        "short": "bucks",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "earn",
        "verbing": "earning",
        "verbone": "earns",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "fame",
        "lol": "",
        "name": "fame",
        "persist": "",
        "plural": "fame",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "driving",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "fame",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Win the race boy!",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "fame",
        "effect.unittype2": "",
        "effect.val": "1",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "race",
        "lol": "",
        "name": "race",
        "persist": "",
        "plural": "race",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "driving",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "race",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "1",
        "label": "Junkmobile",
        "lol": "",
        "name": "car1",
        "persist": "",
        "plural": "Junkmobile",
        "prod.unittype": "money",
        "prod.val": "3.00E+01",
        "requires.op": "",
        "requires.unittype": "money",
        "requires.upgradetype": "",
        "requires.val": "0",
        "short": "Junkmobile",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "The great lusers mobile",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Orel Corsan",
        "lol": "",
        "name": "car2",
        "persist": "",
        "plural": "Orel Corsan",
        "prod.unittype": "money",
        "prod.val": "6.00E+02",
        "requires.op": "",
        "requires.unittype": "car1",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Orel Corsan",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "The next best thing for great lusers on the automobile world",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Frod Exort",
        "lol": "",
        "name": "car3",
        "persist": "",
        "plural": "Frod Exort",
        "prod.unittype": "money",
        "prod.val": "5.40E+04",
        "requires.op": "",
        "requires.unittype": "car2",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Frod Exort",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Pernik's finest automobile",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "VW Volf",
        "lol": "",
        "name": "car4",
        "persist": "",
        "plural": "VW Volf",
        "prod.unittype": "money",
        "prod.val": "2.97E+07",
        "requires.op": "",
        "requires.unittype": "car3",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "VW Volf",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "No one can predict the power under it's hood",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Hord Mocus",
        "lol": "",
        "name": "car5",
        "persist": "",
        "plural": "Hord Mocus",
        "prod.unittype": "money",
        "prod.val": "2.85E+11",
        "requires.op": "",
        "requires.unittype": "car4",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Hord Mocus",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Ultimate power for ultimate red neck",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Godge Discharger",
        "lol": "",
        "name": "car6",
        "persist": "",
        "plural": "Godge Discharger",
        "prod.unittype": "money",
        "prod.val": "7.23E+16",
        "requires.op": "",
        "requires.unittype": "car5",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Godge Discharger",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Guess what, this is just a car",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Linnen 366X",
        "lol": "",
        "name": "car7",
        "persist": "",
        "plural": "Linnen 366X",
        "prod.unittype": "money",
        "prod.val": "9.53E+23",
        "requires.op": "",
        "requires.unittype": "car6",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Linnen 366X",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Starting to get exciting ehh?",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "MBW 3M",
        "lol": "",
        "name": "car8",
        "persist": "",
        "plural": "MBW 3M",
        "prod.unittype": "money",
        "prod.val": "1.28E+33",
        "requires.op": "",
        "requires.unittype": "car7",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "MBW 3M",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "The mucles are incredible",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Godge Venom",
        "lol": "",
        "name": "car9",
        "persist": "",
        "plural": "Godge Venom",
        "prod.unittype": "money",
        "prod.val": "3.47E+44",
        "requires.op": "",
        "requires.unittype": "car8",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Godge Venom",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Better and better",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "MBW 6M",
        "lol": "",
        "name": "car10",
        "persist": "",
        "plural": "MBW 6M",
        "prod.unittype": "money",
        "prod.val": "3.78E+58",
        "requires.op": "",
        "requires.unittype": "car9",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "MBW 6M",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Now we are talkin'",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Rhamboginny gallileo",
        "lol": "",
        "name": "car11",
        "persist": "",
        "plural": "Rhamboginny gallileo",
        "prod.unittype": "money",
        "prod.val": "3.30E+75",
        "requires.op": "",
        "requires.unittype": "car10",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Rhamboginny gallileo",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "Classics never die",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Racho 112 g3t",
        "lol": "",
        "name": "car12",
        "persist": "",
        "plural": "Racho 112 g3t",
        "prod.unittype": "money",
        "prod.val": "4.62E+95",
        "requires.op": "",
        "requires.unittype": "car11",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Racho 112 g3t",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "The pretentendent",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "1f∞",
        "lol": "",
        "name": "car13",
        "persist": "",
        "plural": "1f∞",
        "prod.unittype": "money",
        "prod.val": "2.07E+119",
        "requires.op": "",
        "requires.unittype": "car12",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "1f∞",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Alon Missin BD9",
        "lol": "",
        "name": "car14",
        "persist": "",
        "plural": "Alon Missin BD9",
        "prod.unittype": "money",
        "prod.val": "5.94E+146",
        "requires.op": "",
        "requires.unittype": "car13",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Alon Missin BD9",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Berkley Island GTI",
        "lol": "",
        "name": "car15",
        "persist": "",
        "plural": "Berkley Island GTI",
        "prod.unittype": "money",
        "prod.val": "2.18E+178",
        "requires.op": "",
        "requires.unittype": "car14",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Berkley Island GTI",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "☮ SSS GMA",
        "lol": "",
        "name": "car16",
        "persist": "",
        "plural": "☮ SSS GMA",
        "prod.unittype": "money",
        "prod.val": "2.05E+214",
        "requires.op": "",
        "requires.unittype": "car15",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "☮ SSS GMA",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Sani RGT",
        "lol": "",
        "name": "car17",
        "persist": "",
        "plural": "Sani RGT",
        "prod.unittype": "money",
        "prod.val": "9.89E+254",
        "requires.op": "",
        "requires.unittype": "car16",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Sani RGT",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Biellari F&F",
        "lol": "",
        "name": "car18",
        "persist": "",
        "plural": "Biellari F&F",
        "prod.unittype": "money",
        "prod.val": "4.88E+300",
        "requires.op": "",
        "requires.unittype": "car17",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Biellari F&F",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Rhamboginny Coriodor",
        "lol": "",
        "name": "car19",
        "persist": "",
        "plural": "Rhamboginny Coriodor",
        "prod.unittype": "money",
        "prod.val": "4.9253E+351",
        "requires.op": "",
        "requires.unittype": "car18",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Rhamboginny Coriodor",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Biellari 358",
        "lol": "",
        "name": "car20",
        "persist": "",
        "plural": "Biellari 358",
        "prod.unittype": "money",
        "prod.val": "2.0375E+408",
        "requires.op": "",
        "requires.unittype": "car19",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Biellari 358",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Sabani Londa F",
        "lol": "",
        "name": "car21",
        "persist": "",
        "plural": "Sabani Londa F",
        "prod.unittype": "money",
        "prod.val": "6.9051E+470",
        "requires.op": "",
        "requires.unittype": "car20",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Sabani Londa F",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "McKenzee P1",
        "lol": "",
        "name": "car22",
        "persist": "",
        "plural": "McKenzee P1",
        "prod.unittype": "money",
        "prod.val": "3.8341E+539",
        "requires.op": "",
        "requires.unittype": "car21",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "McKenzee P1",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Sabani Whyhra",
        "lol": "",
        "name": "car23",
        "persist": "",
        "plural": "Sabani Whyhra",
        "prod.unittype": "money",
        "prod.val": "6.9758E+614",
        "requires.op": "",
        "requires.unittype": "car22",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Sabani Whyhra",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Sabatt Pieron",
        "lol": "",
        "name": "car24",
        "persist": "",
        "plural": "Sabatt Pieron",
        "prod.unittype": "money",
        "prod.val": "8.3179E+696",
        "requires.op": "",
        "requires.unittype": "car23",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Sabatt Pieron",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Zyxwvutsrqpo RXCC",
        "lol": "",
        "name": "car25",
        "persist": "",
        "plural": "Zyxwvutsrqpo RXCC",
        "prod.unittype": "money",
        "prod.val": "1.3000E+786",
        "requires.op": "",
        "requires.unittype": "car24",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Zyxwvutsrqpo RXCC",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Zyxwvutsrqpo Adela",
        "lol": "",
        "name": "car26",
        "persist": "",
        "plural": "Zyxwvutsrqpo Adela",
        "prod.unittype": "money",
        "prod.val": "5.3261E+882",
        "requires.op": "",
        "requires.unittype": "car25",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Zyxwvutsrqpo Adela",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Traki 7±2",
        "lol": "",
        "name": "car27",
        "persist": "",
        "plural": "Traki 7±2",
        "prod.unittype": "money",
        "prod.val": "1.1440E+987",
        "requires.op": "",
        "requires.unittype": "car26",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Traki 7±2",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Puldin CC",
        "lol": "",
        "name": "car28",
        "persist": "",
        "plural": "Puldin CC",
        "prod.unittype": "money",
        "prod.val": "2.5767E+1099",
        "requires.op": "",
        "requires.unittype": "car27",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Puldin CC",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Omurtag TX",
        "lol": "",
        "name": "car29",
        "persist": "",
        "plural": "Omurtag TX",
        "prod.unittype": "money",
        "prod.val": "1.2171E+1220",
        "requires.op": "",
        "requires.unittype": "car28",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Omurtag TX",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Tangra XR",
        "lol": "",
        "name": "car30",
        "persist": "",
        "plural": "Tangra XR",
        "prod.unittype": "money",
        "prod.val": "2.4113E+1349",
        "requires.op": "",
        "requires.unittype": "car29",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "Tangra XR",
        "showparent": "",
        "tab": "money",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "technology",
        "cost.val": "1.00E+01",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "mechanic",
        "lol": "",
        "name": "tech1",
        "persist": "",
        "plural": "mechanics",
        "prod.unittype": "technology",
        "prod.val": "1.00E+00",
        "requires.op": "",
        "requires.unittype": "car1",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "mech",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "hire",
        "verbing": "hiring",
        "verbone": "hires",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "2.00E+02",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech1",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech1",
        "cost.val": "1.00E+02",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "supervisor",
        "lol": "",
        "name": "tech2",
        "persist": "",
        "plural": "supervisors",
        "prod.unittype": "tech1",
        "prod.val": "2.00E+00",
        "requires.op": "",
        "requires.unittype": "tech1",
        "requires.upgradetype": "",
        "requires.val": "10",
        "short": "supvr",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "hire",
        "verbing": "hiring",
        "verbone": "hires",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "2.00E+03",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech2",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech2",
        "cost.val": "1.00E+03",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "brigade",
        "lol": "",
        "name": "tech3",
        "persist": "",
        "plural": "brigades",
        "prod.unittype": "tech2",
        "prod.val": "3.00E+00",
        "requires.op": "",
        "requires.unittype": "tech2",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "brgd",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "hire",
        "verbing": "hiring",
        "verbone": "hires",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "4.00E+04",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech3",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech3",
        "cost.val": "2.00E+04",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "technology facility",
        "lol": "",
        "name": "tech4",
        "persist": "",
        "plural": "technology facilities",
        "prod.unittype": "tech3",
        "prod.val": "5.00E+00",
        "requires.op": "",
        "requires.unittype": "tech3",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "facs",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "construct",
        "verbing": "constructing",
        "verbone": "constructs",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "1.20E+06",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech4",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech4",
        "cost.val": "6.00E+05",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "technology center",
        "lol": "",
        "name": "tech5",
        "persist": "",
        "plural": "technology centers",
        "prod.unittype": "tech4",
        "prod.val": "8.00E+00",
        "requires.op": "",
        "requires.unittype": "tech4",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "ctrs",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "construct",
        "verbing": "constructing",
        "verbone": "constructs",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "6.00E+07",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech5",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech5",
        "cost.val": "3.00E+07",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "technology campus",
        "lol": "",
        "name": "tech6",
        "persist": "",
        "plural": "technology campuses",
        "prod.unittype": "tech5",
        "prod.val": "1.30E+01",
        "requires.op": "",
        "requires.unittype": "tech5",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "camps",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "construct",
        "verbing": "constructing",
        "verbone": "constructs",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "4.80E+09",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech6",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech6",
        "cost.val": "2.40E+09",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "technology complex",
        "lol": "",
        "name": "tech7",
        "persist": "",
        "plural": "technology complexes",
        "prod.unittype": "tech6",
        "prod.val": "2.10E+01",
        "requires.op": "",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "cplx",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "construct",
        "verbing": "constructing",
        "verbone": "constructs",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "6.24E+11",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech7",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech7",
        "cost.val": "3.12E+11",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "technology cluster",
        "lol": "",
        "name": "tech8",
        "persist": "",
        "plural": "technology clusters",
        "prod.unittype": "tech7",
        "prod.val": "3.40E+01",
        "requires.op": "",
        "requires.unittype": "tech7",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "cltrs",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "construct",
        "verbing": "constructing",
        "verbone": "constructs",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "1.31E+14",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech8",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech8",
        "cost.val": "6.55E+13",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "technology neuron",
        "lol": "",
        "name": "tech9",
        "persist": "",
        "plural": "technology neurons",
        "prod.unittype": "tech8",
        "prod.val": "5.50E+01",
        "requires.op": "",
        "requires.unittype": "tech8",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "neuns",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "construct",
        "verbing": "constructing",
        "verbone": "constructs",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "4.46E+16",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech9",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech9",
        "cost.val": "2.23E+16",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "neuron network",
        "lol": "",
        "name": "tech10",
        "persist": "",
        "plural": "neuron networks",
        "prod.unittype": "tech9",
        "prod.val": "8.90E+01",
        "requires.op": "",
        "requires.unittype": "tech9",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "n.n.",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "develop",
        "verbing": "developing",
        "verbone": "develops",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "2.45E+19",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech10",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech10",
        "cost.val": "1.23E+19",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "artificial intelligence",
        "lol": "",
        "name": "tech11",
        "persist": "",
        "plural": "artificial intelligences",
        "prod.unittype": "tech10",
        "prod.val": "1.44E+02",
        "requires.op": "",
        "requires.unittype": "tech10",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "a.i.",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "develop",
        "verbing": "developing",
        "verbone": "develops",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "2.18E+22",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech11",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech11",
        "cost.val": "1.09E+22",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "artificial colony",
        "lol": "",
        "name": "tech12",
        "persist": "",
        "plural": "artificial colonies",
        "prod.unittype": "tech11",
        "prod.val": "2.33E+02",
        "requires.op": "",
        "requires.unittype": "tech11",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "a cols",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "develop",
        "verbing": "developing",
        "verbone": "develops",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "3.14E+25",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech12",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech12",
        "cost.val": "1.57E+25",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "artificial civilization",
        "lol": "",
        "name": "tech13",
        "persist": "",
        "plural": "artificial civilizations",
        "prod.unittype": "tech12",
        "prod.val": "3.77E+02",
        "requires.op": "",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "a civs",
        "showparent": "",
        "tab": "technology",
        "unbuyable": "",
        "verb": "develop",
        "verbing": "developing",
        "verbone": "develops",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "money",
        "cost.val": "7.32E+28",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "tech13",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+03",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "newsboy",
        "lol": "",
        "name": "sponsor1",
        "persist": "",
        "plural": "newsboys",
        "prod.unittype": "money",
        "prod.val": "1000",
        "requires.op": "",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "0",
        "short": "newsboys",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech1",
        "cost.val": "100000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor1",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+05",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "school newspaper",
        "lol": "",
        "name": "sponsor2",
        "persist": "",
        "plural": "school newspapers",
        "prod.unittype": "money",
        "prod.val": "1000000",
        "requires.op": "",
        "requires.unittype": "tech2",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "schl nwsp",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech2",
        "cost.val": "75000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor2",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+08",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "village newspaper",
        "lol": "",
        "name": "sponsor3",
        "persist": "",
        "plural": "village newspapers",
        "prod.unittype": "money",
        "prod.val": "10000000000",
        "requires.op": "",
        "requires.unittype": "tech3",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "vlg nwsp",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech3",
        "cost.val": "50000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor3",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+12",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "city newspaper",
        "lol": "",
        "name": "sponsor4",
        "persist": "",
        "plural": "city newspapers",
        "prod.unittype": "money",
        "prod.val": "1E+15",
        "requires.op": "",
        "requires.unittype": "tech4",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "city nwsp",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech4",
        "cost.val": "37500",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor4",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+17",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "newspaper",
        "lol": "",
        "name": "sponsor5",
        "persist": "",
        "plural": "newspapers",
        "prod.unittype": "money",
        "prod.val": "1E+21",
        "requires.op": "",
        "requires.unittype": "tech5",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "nwsp",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech5",
        "cost.val": "30000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor5",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+23",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "local magazine",
        "lol": "",
        "name": "sponsor6",
        "persist": "",
        "plural": "local magazines",
        "prod.unittype": "money",
        "prod.val": "1E+28",
        "requires.op": "",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "loc mags",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech6",
        "cost.val": "20000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor6",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+29",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "magazine",
        "lol": "",
        "name": "sponsor7",
        "persist": "",
        "plural": "magazines",
        "prod.unittype": "money",
        "prod.val": "1E+36",
        "requires.op": "",
        "requires.unittype": "tech7",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "mags",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech7",
        "cost.val": "15000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor7",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+36",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "international magazine",
        "lol": "",
        "name": "sponsor8",
        "persist": "",
        "plural": "international magazines",
        "prod.unittype": "money",
        "prod.val": "1E+45",
        "requires.op": "",
        "requires.unittype": "tech8",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "intl mags",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech8",
        "cost.val": "12500",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor8",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+44",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "radio station",
        "lol": "",
        "name": "sponsor9",
        "persist": "",
        "plural": "radio stations",
        "prod.unittype": "money",
        "prod.val": "1E+55",
        "requires.op": "",
        "requires.unittype": "tech9",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "rdo sts",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech9",
        "cost.val": "10000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor9",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+53",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "radio network",
        "lol": "",
        "name": "sponsor10",
        "persist": "",
        "plural": "radio networks",
        "prod.unittype": "money",
        "prod.val": "1E+66",
        "requires.op": "",
        "requires.unittype": "tech10",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "rdo nets",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech10",
        "cost.val": "8000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor10",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+63",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "tv station",
        "lol": "",
        "name": "sponsor11",
        "persist": "",
        "plural": "tv stations",
        "prod.unittype": "money",
        "prod.val": "1E+78",
        "requires.op": "",
        "requires.unittype": "tech11",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "tv sts",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech11",
        "cost.val": "6000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor11",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fame",
        "cost.val": "1.00E+74",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "tv network",
        "lol": "",
        "name": "sponsor12",
        "persist": "",
        "plural": "tv networks",
        "prod.unittype": "money",
        "prod.val": "1E+91",
        "requires.op": "",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "tv nets",
        "showparent": "",
        "tab": "fame",
        "unbuyable": "",
        "verb": "find",
        "verbing": "finding",
        "verbone": "finds",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "tech12",
        "cost.val": "5000",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "sponsor12",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "upgrades",
        "lol": "",
        "name": "upgrades",
        "persist": "",
        "plural": "upgrades",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "technology",
        "requires.upgradetype": "",
        "requires.val": "1.00E+20",
        "short": "upgrades",
        "showparent": "",
        "tab": "upgrades",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "racer",
        "lol": "",
        "name": "autoclicker",
        "persist": "",
        "plural": "racers",
        "prod.unittype": "fame",
        "prod.val": "0",
        "requires.op": "",
        "requires.unittype": "technology",
        "requires.upgradetype": "",
        "requires.val": "1.00E+16",
        "short": "racers",
        "showparent": "",
        "tab": "hidden",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "",
        "lol": "",
        "name": "autoclicker",
        "persist": "",
        "plural": "",
        "prod.unittype": "fake_fame",
        "prod.val": "0",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Upgrade cars",
        "lol": "",
        "name": "upgrade_cars",
        "persist": "",
        "plural": "Upgrade cars",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "technology",
        "requires.upgradetype": "",
        "requires.val": "1.00E+20",
        "short": "cars",
        "showparent": "",
        "tab": "upgrades",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "Upgrade sponsors",
        "lol": "",
        "name": "upgrade_sponsors",
        "persist": "",
        "plural": "Upgrade sponsors",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "technology",
        "requires.upgradetype": "",
        "requires.val": "5.00E+52",
        "short": "sponsors",
        "showparent": "",
        "tab": "upgrades",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "fake_fame",
        "cost.val": "1.00E+00",
        "description": "",
        "disabled": "TRUE",
        "effect.stat": "prod",
        "effect.type": "logStat2",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.val": "5",
        "effect.val2": "1.00E+15",
        "effect.val3": "43",
        "init": "",
        "label": "Experience",
        "lol": "",
        "name": "experience",
        "persist": "TRUE",
        "plural": "Experience",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "experience",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "exp",
        "showparent": "",
        "tab": "hidden",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "",
        "effect.stat": "prod",
        "effect.type": "logStat2",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.val": "5",
        "effect.val2": "1.00E+15",
        "effect.val3": "43",
        "init": "",
        "label": "",
        "lol": "",
        "name": "experience",
        "persist": "",
        "plural": "",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "",
        "unbuyable": "",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "total ascensions",
        "disabled": "TRUE",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "ascension",
        "lol": "",
        "name": "ascension",
        "persist": "TRUE",
        "plural": "ascension",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "showparent": "",
        "tab": "hidden",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "TRUE",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "racing",
        "lol": "",
        "name": "racing",
        "persist": "",
        "plural": "racing",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "racing",
        "requires.upgradetype": "",
        "requires.val": "0",
        "short": "",
        "showparent": "",
        "tab": "hidden",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      },
      {
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "disabled": "TRUE",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.val": "",
        "effect.val2": "",
        "effect.val3": "",
        "init": "",
        "label": "upgrade_driving",
        "lol": "",
        "name": "upgrade_driving",
        "persist": "",
        "plural": "upgrade_driving",
        "prod.unittype": "",
        "prod.val": "",
        "requires.op": "",
        "requires.unittype": "upgrade_driving",
        "requires.upgradetype": "",
        "requires.val": "0",
        "short": "",
        "showparent": "",
        "tab": "hidden",
        "unbuyable": "TRUE",
        "verb": "",
        "verbing": "",
        "verbone": "",
        "warnfirst.text": "",
        "warnfirst.unittype": "",
        "warnfirst.val": ""
      }
    ],
    "name": "unittypes"
  },
  "upgrades": {
    "column_names": [
      "name",
      "label",
      "description",
      "short",
      "template",
      "lol",
      "maxlevel",
      "class",
      "unittype",
      "requires.unittype",
      "requires.upgradetype",
      "requires.val",
      "cost.unittype",
      "cost.val",
      "cost.factor",
      "effect.type",
      "effect.unittype",
      "effect.upgradetype",
      "effect.val",
      "effect.stat",
      "effect.val2",
      "effect.unittype2"
    ],
    "elements": [
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "10000",
        "description": "Own a Orel Corsan and unlock racing",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Orel Corsan",
        "lol": "",
        "maxlevel": "1",
        "name": "car2_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car2"
      },
      {
        "class": "",
        "cost.factor": "1",
        "cost.unittype": "technology",
        "cost.val": "100000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car2_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1800000",
        "description": "Own a Frod Exort and increase fame from racing with 20",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Frod Exort",
        "lol": "",
        "maxlevel": "1",
        "name": "car3_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car3"
      },
      {
        "class": "",
        "cost.factor": "1",
        "cost.unittype": "technology",
        "cost.val": "160000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "20",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car3_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "8100000000",
        "description": "Own a VW Volf and increase fame from racing with 2000",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy VW Volf",
        "lol": "",
        "maxlevel": "1",
        "name": "car4_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car4"
      },
      {
        "class": "",
        "cost.factor": "1",
        "cost.unittype": "technology",
        "cost.val": "16384000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car4_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "2332800000000000",
        "description": "Own a Hord Mocus and increase fame from racing with 400000",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Hord Mocus",
        "lol": "",
        "maxlevel": "1",
        "name": "car5_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car5"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "429496729600000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "400000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car5_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "131681894400000000000000",
        "description": "Own a Godge Discharger and increase fame from racing with 240000000",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Godge Discharger",
        "lol": "",
        "maxlevel": "1",
        "name": "car6_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car6"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "11529215046068500000000000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "240000000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car6_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "5827612786871500000000000000000000",
        "description": "Own a Linnen 366X and increase fame from racing with 720000000000",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Linnen 366X",
        "lol": "",
        "maxlevel": "1",
        "name": "car7_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car7"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "1.27E+45",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.20E+11",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car7_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "8.09E+47",
        "description": "Own a MBW 3M and increase fame from racing with 1.728E+16",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy MBW 3M",
        "lol": "",
        "maxlevel": "1",
        "name": "car8_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car8"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "2.28E+63",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.73E+16",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car8_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.41E+66",
        "description": "Own a Godge Venom and increase fame from racing with 5.39136E+21",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Godge Venom",
        "lol": "",
        "maxlevel": "1",
        "name": "car9_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car9"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "2.70E+86",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "5.39E+21",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car9_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.2299E+89",
        "description": "Own a MBW 6M and increase fame from racing with 3.5324E+28",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy MBW 6M",
        "lol": "",
        "maxlevel": "1",
        "name": "car10_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car10"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "8.3439E+0114",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.5324E+28",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car10_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.2129E+117",
        "description": "Own a Rhamboginny gallileo and increase fame from racing with 7.8691E+36",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Rhamboginny gallileo",
        "lol": "",
        "maxlevel": "1",
        "name": "car11_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car11"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "2.7078E+0150",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.8691E+36",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car11_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "3.7510E+150",
        "description": "Own a Racho 112 g3t and increase fame from racing with 9.6412E+47",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Racho 112 g3t",
        "lol": "",
        "maxlevel": "1",
        "name": "car12_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car12"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "3.6856E+0194",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.6412E+47",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "9.3130E+189",
        "description": "Own a 1f∞ and increase fame from racing with 1.0513E+60",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car13",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy 1f∞",
        "lol": "",
        "maxlevel": "1",
        "name": "car13_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car13"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "8.4164E+0248",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0513E+60",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "4.9018E+235",
        "description": "Own a Alon Missin BD9 and increase fame from racing with 1.6508E+74",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car14",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Alon Missin BD9",
        "lol": "",
        "maxlevel": "1",
        "name": "car14_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car14"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "1.2898E+0315",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.6508E+74",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.4273E+288",
        "description": "Own a Berkley Island GTI and increase fame from racing with 6.0398E+90",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car15",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Berkley Island GTI",
        "lol": "",
        "maxlevel": "1",
        "name": "car15_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car15"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "5.3060E+0394",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "6.0398E+90",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "6.0263E+347",
        "description": "Own a ☮ SSS GMA and increase fame from racing with 8.3307E+109",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car16",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy ☮ SSS GMA",
        "lol": "",
        "maxlevel": "1",
        "name": "car16_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car16"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "2.3437E+0489",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "8.3307E+109",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "9.6547E+415",
        "description": "Own a Sani RGT and increase fame from racing with 7.0094E+131",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car17",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Sani RGT",
        "lol": "",
        "maxlevel": "1",
        "name": "car17_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car17"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "4.4462E+0600",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.0094E+131",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.5369E+491",
        "description": "Own a Biellari F&F and increase fame from racing with 5.8210E+156",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car18",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Biellari F&F",
        "lol": "",
        "maxlevel": "1",
        "name": "car18_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car18"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "1.4491E+0730",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "5.8210E+156",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "6.3638E+574",
        "description": "Own a Rhamboginny Coriodor and increase fame from racing with 7.7198E+184",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car19",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Rhamboginny Coriodor",
        "lol": "",
        "maxlevel": "1",
        "name": "car19_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car19"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "3.2455E+0879",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.7198E+184",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.7945E+667",
        "description": "Own a Biellari 358 and increase fame from racing with 2.6456E+216",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car20",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Biellari 358",
        "lol": "",
        "maxlevel": "1",
        "name": "car20_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car20"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "1.9981E+1050",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.6456E+216",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "9.0217E+768",
        "description": "Own a Sabani Londa F and increase fame from racing with 3.7906E+251",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car21",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Sabani Londa F",
        "lol": "",
        "maxlevel": "1",
        "name": "car21_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car21"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "1.3526E+1244",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.7906E+251",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "2.1170E+880",
        "description": "Own a McKenzee P1 and increase fame from racing with 3.6742E+290",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car22",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy McKenzee P1",
        "lol": "",
        "maxlevel": "1",
        "name": "car22_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car22"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "4.0268E+1462",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.6742E+290",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "6.0705E+1001",
        "description": "Own a Sabani Whyhra and increase fame from racing with 3.8983E+333",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car23",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Sabani Whyhra",
        "lol": "",
        "maxlevel": "1",
        "name": "car23_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car23"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "2.1090E+1707",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.8983E+333",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "5.5690E+1133",
        "description": "Own a Sabatt Pieron and increase fame from racing with 7.3253E+380",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car24",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Sabatt Pieron",
        "lol": "",
        "maxlevel": "1",
        "name": "car24_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car24"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "7.7727E+1979",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.3253E+380",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "4.2791E+1276",
        "description": "Own a Zyxwvutsrqpo RXCC and increase fame from racing with 3.9447E+432",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car25",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Zyxwvutsrqpo RXCC",
        "lol": "",
        "maxlevel": "1",
        "name": "car25_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car25"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "8.0634E+2281",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.9447E+432",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "7.2099E+1461",
        "description": "Own a Zyxwvutsrqpo Adela and increase fame from racing with 9.8495E+489",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car26",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Zyxwvutsrqpo Adela",
        "lol": "",
        "maxlevel": "1",
        "name": "car26_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car26"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "9.4172E+2614",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.8495E+489",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "6.9738E+1658",
        "description": "Own a Traki 7±2 and increase fame from racing with 1.8451E+551",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car27",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Traki 7±2",
        "lol": "",
        "maxlevel": "1",
        "name": "car27_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car27"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "4.9535E+2980",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8451E+551",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "1.0138E+1868",
        "description": "Own a Puldin CC and increase fame from racing with 4.1959E+617",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car28",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Puldin CC",
        "lol": "",
        "maxlevel": "1",
        "name": "car28_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car28"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "4.6938E+3380",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.1959E+617",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "5.7991E+2089",
        "description": "Own a Omurtag TX and increase fame from racing with 1.8742E+689",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car29",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Omurtag TX",
        "lol": "",
        "maxlevel": "1",
        "name": "car29_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car29"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "3.2049E+3816",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8742E+689",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "money",
        "cost.val": "3.4172E+2324",
        "description": "Own a Tangra XR and increase fame from racing with 2.6606E+766",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "car30",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Buy Tangra XR",
        "lol": "",
        "maxlevel": "1",
        "name": "car30_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "BUY",
        "template": "cars_buy.html",
        "unittype": "car30"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "technology",
        "cost.val": "6.3074E+4289",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.6606E+766",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "2.5",
        "cost.unittype": "money",
        "cost.val": "200",
        "description": "Increase bucks multiplier with 1 and fame from racing with ",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car1",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Junkmobile",
        "lol": "",
        "maxlevel": "",
        "name": "car1_upgrade",
        "requires.unittype": "car1",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car1"
      },
      {
        "class": "",
        "cost.factor": "2.5",
        "cost.unittype": "technology",
        "cost.val": "500",
        "description": "",
        "effect.stat": "",
        "effect.type": "",
        "effect.unittype": "",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car1_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "2.625",
        "cost.unittype": "money",
        "cost.val": "10000",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Orel Corsan",
        "lol": "",
        "maxlevel": "",
        "name": "car2_upgrade",
        "requires.unittype": "car2",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car2"
      },
      {
        "class": "",
        "cost.factor": "3",
        "cost.unittype": "technology",
        "cost.val": "100000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car2_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "2.75",
        "cost.unittype": "money",
        "cost.val": "3600000",
        "description": "Increase bucks multiplier with 1 and fame from racing with 10",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Frod Exort",
        "lol": "",
        "maxlevel": "",
        "name": "car3_upgrade",
        "requires.unittype": "car3",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car3"
      },
      {
        "class": "",
        "cost.factor": "3.5",
        "cost.unittype": "technology",
        "cost.val": "560000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "10",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car3_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "3",
        "cost.unittype": "money",
        "cost.val": "16200000000",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1000",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade VW Volf",
        "lol": "",
        "maxlevel": "",
        "name": "car4_upgrade",
        "requires.unittype": "car4",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car4"
      },
      {
        "class": "",
        "cost.factor": "4",
        "cost.unittype": "technology",
        "cost.val": "65536000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car4_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "3.5",
        "cost.unittype": "money",
        "cost.val": "4665600000000000",
        "description": "Increase bucks multiplier with 1 and fame from racing with 200000",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Hord Mocus",
        "lol": "",
        "maxlevel": "",
        "name": "car5_upgrade",
        "requires.unittype": "car5",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car5"
      },
      {
        "class": "",
        "cost.factor": "5",
        "cost.unittype": "technology",
        "cost.val": "2147483648000000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "200000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car5_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "4",
        "cost.unittype": "money",
        "cost.val": "395045683200000000000000",
        "description": "Increase bucks multiplier with 1 and fame from racing with 120000000",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Godge Discharger",
        "lol": "",
        "maxlevel": "",
        "name": "car6_upgrade",
        "requires.unittype": "car6",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car6"
      },
      {
        "class": "",
        "cost.factor": "10",
        "cost.unittype": "technology",
        "cost.val": "115292150460685000000000000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "120000000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car6_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "5",
        "cost.unittype": "money",
        "cost.val": "58276127868715000000000000000000000",
        "description": "Increase bucks multiplier with 1 and fame from racing with 360000000000",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Linnen 366X",
        "lol": "",
        "maxlevel": "",
        "name": "car7_upgrade",
        "requires.unittype": "car7",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car7"
      },
      {
        "class": "",
        "cost.factor": "15",
        "cost.unittype": "technology",
        "cost.val": "19014759003423400000000000000000000000000000000",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "360000000000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car7_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "money",
        "cost.val": "8.09E+49",
        "description": "Increase bucks multiplier with 1 and fame from racing with 8.64E+15",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade MBW 3M",
        "lol": "",
        "maxlevel": "",
        "name": "car8_upgrade",
        "requires.unittype": "car8",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car8"
      },
      {
        "class": "",
        "cost.factor": "20",
        "cost.unittype": "technology",
        "cost.val": "4.57E+64",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "8640000000000000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car8_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "20",
        "cost.unittype": "money",
        "cost.val": "1.41E+69",
        "description": "Increase bucks multiplier with 1 and fame from racing with 2.69568E+21",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Godge Venom",
        "lol": "",
        "maxlevel": "",
        "name": "car9_upgrade",
        "requires.unittype": "car9",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car9"
      },
      {
        "class": "",
        "cost.factor": "35",
        "cost.unittype": "technology",
        "cost.val": "9.44E+87",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2695680000000000000000",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car9_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "30",
        "cost.unittype": "money",
        "cost.val": "1.2299E+93",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.7662E+30",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade MBW 6M",
        "lol": "",
        "maxlevel": "",
        "name": "car10_upgrade",
        "requires.unittype": "car10",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car10"
      },
      {
        "class": "",
        "cost.factor": "50",
        "cost.unittype": "technology",
        "cost.val": "4.1720E+116",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.7662E+30",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car10_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "40",
        "cost.unittype": "money",
        "cost.val": "1.2129E+122",
        "description": "Increase bucks multiplier with 1 and fame from racing with 3.9346E+38",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Rhamboginny gallileo",
        "lol": "",
        "maxlevel": "",
        "name": "car11_upgrade",
        "requires.unittype": "car11",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car11"
      },
      {
        "class": "",
        "cost.factor": "100",
        "cost.unittype": "technology",
        "cost.val": "2.7078E+152",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.9346E+38",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car11_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "50",
        "cost.unittype": "money",
        "cost.val": "3.7510E+156",
        "description": "Increase bucks multiplier with 1 and fame from racing with 4.8206E+49",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Racho 112 g3t",
        "lol": "",
        "maxlevel": "",
        "name": "car12_upgrade",
        "requires.unittype": "car12",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car12"
      },
      {
        "class": "",
        "cost.factor": "250",
        "cost.unittype": "technology",
        "cost.val": "9.2140E+196",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.8206E+49",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "60",
        "cost.unittype": "money",
        "cost.val": "9.3130E+196",
        "description": "Increase bucks multiplier with 1 and fame from racing with 5.2565E+61",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car13",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade 1f∞",
        "lol": "",
        "maxlevel": "",
        "name": "car13_upgrade",
        "requires.unittype": "car13",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car13"
      },
      {
        "class": "",
        "cost.factor": "500",
        "cost.unittype": "technology",
        "cost.val": "4.2082E+251",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "5.2565E+61",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "70",
        "cost.unittype": "money",
        "cost.val": "4.9018E+243",
        "description": "Increase bucks multiplier with 1 and fame from racing with 8.2540E+75",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car14",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Alon Missin BD9",
        "lol": "",
        "maxlevel": "",
        "name": "car14_upgrade",
        "requires.unittype": "car14",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car14"
      },
      {
        "class": "",
        "cost.factor": "1000",
        "cost.unittype": "technology",
        "cost.val": "1.2898E+318",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "8.2540E+75",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "80",
        "cost.unittype": "money",
        "cost.val": "1.4273E+297",
        "description": "Increase bucks multiplier with 1 and fame from racing with 3.0199E+92",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car15",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Berkley Island GTI",
        "lol": "",
        "maxlevel": "",
        "name": "car15_upgrade",
        "requires.unittype": "car15",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car15"
      },
      {
        "class": "",
        "cost.factor": "2500",
        "cost.unittype": "technology",
        "cost.val": "1.3265E+398",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.0199E+92",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "90",
        "cost.unittype": "money",
        "cost.val": "6.0263E+357",
        "description": "Increase bucks multiplier with 1 and fame from racing with 4.1654E+111",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car16",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade ☮ SSS GMA",
        "lol": "",
        "maxlevel": "",
        "name": "car16_upgrade",
        "requires.unittype": "car16",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car16"
      },
      {
        "class": "",
        "cost.factor": "5000",
        "cost.unittype": "technology",
        "cost.val": "1.1719E+493",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.1654E+111",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "100",
        "cost.unittype": "money",
        "cost.val": "9.6547E+427",
        "description": "Increase bucks multiplier with 1 and fame from racing with 3.5047E+133",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car17",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Sani RGT",
        "lol": "",
        "maxlevel": "",
        "name": "car17_upgrade",
        "requires.unittype": "car17",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car17"
      },
      {
        "class": "",
        "cost.factor": "10000",
        "cost.unittype": "technology",
        "cost.val": "4.4462E+604",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.5047E+133",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "110",
        "cost.unittype": "money",
        "cost.val": "1.5369E+503",
        "description": "Increase bucks multiplier with 1 and fame from racing with 2.9105E+158",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car18",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Biellari F&F",
        "lol": "",
        "maxlevel": "",
        "name": "car18_upgrade",
        "requires.unittype": "car18",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car18"
      },
      {
        "class": "",
        "cost.factor": "25000",
        "cost.unittype": "technology",
        "cost.val": "3.6228E+734",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.9105E+158",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "120",
        "cost.unittype": "money",
        "cost.val": "6.3638E+587",
        "description": "Increase bucks multiplier with 1 and fame from racing with 3.8599E+186",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car19",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Rhamboginny Coriodor",
        "lol": "",
        "maxlevel": "",
        "name": "car19_upgrade",
        "requires.unittype": "car19",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car19"
      },
      {
        "class": "",
        "cost.factor": "50000",
        "cost.unittype": "technology",
        "cost.val": "1.6228E+884",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.8599E+186",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "130",
        "cost.unittype": "money",
        "cost.val": "1.7945E+681",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.3228E+218",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car20",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Biellari 358",
        "lol": "",
        "maxlevel": "",
        "name": "car20_upgrade",
        "requires.unittype": "car20",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car20"
      },
      {
        "class": "",
        "cost.factor": "100000",
        "cost.unittype": "technology",
        "cost.val": "1.9981E+1055",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.3228E+218",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "140",
        "cost.unittype": "money",
        "cost.val": "9.0217E+783",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.8953E+253",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car21",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Sabani Londa F",
        "lol": "",
        "maxlevel": "",
        "name": "car21_upgrade",
        "requires.unittype": "car21",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car21"
      },
      {
        "class": "",
        "cost.factor": "250000",
        "cost.unittype": "technology",
        "cost.val": "3.3815E+1249",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8953E+253",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "150",
        "cost.unittype": "money",
        "cost.val": "2.1170E+896",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.8371E+292",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car22",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade McKenzee P1",
        "lol": "",
        "maxlevel": "",
        "name": "car22_upgrade",
        "requires.unittype": "car22",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car22"
      },
      {
        "class": "",
        "cost.factor": "500000",
        "cost.unittype": "technology",
        "cost.val": "2.0134E+1468",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8371E+292",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "160",
        "cost.unittype": "money",
        "cost.val": "6.0705E+1018",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.9492E+335",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car23",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Sabani Whyhra",
        "lol": "",
        "maxlevel": "",
        "name": "car23_upgrade",
        "requires.unittype": "car23",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car23"
      },
      {
        "class": "",
        "cost.factor": "1000000",
        "cost.unittype": "technology",
        "cost.val": "2.1090E+1713",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.9492E+335",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "170",
        "cost.unittype": "money",
        "cost.val": "5.5690E+1151",
        "description": "Increase bucks multiplier with 1 and fame from racing with 3.6627E+382",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car24",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Sabatt Pieron",
        "lol": "",
        "maxlevel": "",
        "name": "car24_upgrade",
        "requires.unittype": "car24",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car24"
      },
      {
        "class": "",
        "cost.factor": "2500000",
        "cost.unittype": "technology",
        "cost.val": "1.9432E+1986",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.6627E+382",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "180",
        "cost.unittype": "money",
        "cost.val": "4.2791E+1295",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.9724E+434",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car25",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Zyxwvutsrqpo RXCC",
        "lol": "",
        "maxlevel": "",
        "name": "car25_upgrade",
        "requires.unittype": "car25",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car25"
      },
      {
        "class": "",
        "cost.factor": "5000000",
        "cost.unittype": "technology",
        "cost.val": "4.0317E+2288",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.9724E+434",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "190",
        "cost.unittype": "money",
        "cost.val": "7.2099E+1481",
        "description": "Increase bucks multiplier with 1 and fame from racing with 4.9248E+491",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car26",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Zyxwvutsrqpo Adela",
        "lol": "",
        "maxlevel": "",
        "name": "car26_upgrade",
        "requires.unittype": "car26",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car26"
      },
      {
        "class": "",
        "cost.factor": "10000000",
        "cost.unittype": "technology",
        "cost.val": "9.4172E+2621",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.9248E+491",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "200",
        "cost.unittype": "money",
        "cost.val": "6.9738E+1679",
        "description": "Increase bucks multiplier with 1 and fame from racing with 9.2255E+552",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car27",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Traki 7±2",
        "lol": "",
        "maxlevel": "",
        "name": "car27_upgrade",
        "requires.unittype": "car27",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car27"
      },
      {
        "class": "",
        "cost.factor": "20000000",
        "cost.unittype": "technology",
        "cost.val": "9.9070E+2988",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.2255E+552",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "210",
        "cost.unittype": "money",
        "cost.val": "1.0138E+1890",
        "description": "Increase bucks multiplier with 1 and fame from racing with 2.0980E+619",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car28",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Puldin CC",
        "lol": "",
        "maxlevel": "",
        "name": "car28_upgrade",
        "requires.unittype": "car28",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car28"
      },
      {
        "class": "",
        "cost.factor": "40000000",
        "cost.unittype": "technology",
        "cost.val": "1.8775E+3388",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.0980E+619",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "220",
        "cost.unittype": "money",
        "cost.val": "5.7991E+2112",
        "description": "Increase bucks multiplier with 1 and fame from racing with 9.3710E+690",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car29",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Omurtag TX",
        "lol": "",
        "maxlevel": "",
        "name": "car29_upgrade",
        "requires.unittype": "car29",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car29"
      },
      {
        "class": "",
        "cost.factor": "80000000",
        "cost.unittype": "technology",
        "cost.val": "2.5639E+3824",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.3710E+690",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "230",
        "cost.unittype": "money",
        "cost.val": "3.4172E+2348",
        "description": "Increase bucks multiplier with 1 and fame from racing with 1.3303E+768",
        "effect.stat": "prod",
        "effect.type": "addStatInc",
        "effect.unittype": "car30",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Upgrade Tangra XR",
        "lol": "",
        "maxlevel": "",
        "name": "car30_upgrade",
        "requires.unittype": "car30",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "cars_upgrade.html",
        "unittype": "car30"
      },
      {
        "class": "",
        "cost.factor": "160000000",
        "cost.unittype": "technology",
        "cost.val": "1.0092E+4298",
        "description": "",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.3303E+768",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "fame",
        "cost.val": "1.00E+02",
        "description": "Double mechanic production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech1",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Train mechanic",
        "lol": "",
        "maxlevel": "15",
        "name": "tech1_prod",
        "requires.unittype": "fame",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech1"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor1",
        "cost.val": "1.00E+02",
        "description": "Double supervisor production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Train supervisor",
        "lol": "",
        "maxlevel": "14",
        "name": "tech2_prod",
        "requires.unittype": "tech2",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech2"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor2",
        "cost.val": "1.00E+02",
        "description": "Double brigade production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Train brigade",
        "lol": "",
        "maxlevel": "13",
        "name": "tech3_prod",
        "requires.unittype": "tech3",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech3"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor3",
        "cost.val": "1.00E+02",
        "description": "Double technology facility production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology facility",
        "lol": "",
        "maxlevel": "12",
        "name": "tech4_prod",
        "requires.unittype": "tech4",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech4"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor4",
        "cost.val": "1.00E+02",
        "description": "Double technology center production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology center",
        "lol": "",
        "maxlevel": "11",
        "name": "tech5_prod",
        "requires.unittype": "tech5",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech5"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor5",
        "cost.val": "1.00E+02",
        "description": "Double technology campus production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology campus",
        "lol": "",
        "maxlevel": "10",
        "name": "tech6_prod",
        "requires.unittype": "tech6",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech6"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor6",
        "cost.val": "1.00E+02",
        "description": "Double technology complex production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology complex",
        "lol": "",
        "maxlevel": "9",
        "name": "tech7_prod",
        "requires.unittype": "tech7",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech7"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor7",
        "cost.val": "1.00E+02",
        "description": "Double technology cluster production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology cluster",
        "lol": "",
        "maxlevel": "8",
        "name": "tech8_prod",
        "requires.unittype": "tech8",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech8"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor8",
        "cost.val": "1.00E+02",
        "description": "Double technology neuron production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology neuron",
        "lol": "",
        "maxlevel": "7",
        "name": "tech9_prod",
        "requires.unittype": "tech9",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech9"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor9",
        "cost.val": "1.00E+02",
        "description": "Double neuron network production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve neuron network",
        "lol": "",
        "maxlevel": "6",
        "name": "tech10_prod",
        "requires.unittype": "tech10",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech10"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor10",
        "cost.val": "1.00E+02",
        "description": "Double artificial intelligence production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve artificial intelligence",
        "lol": "",
        "maxlevel": "5",
        "name": "tech11_prod",
        "requires.unittype": "tech11",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech11"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor11",
        "cost.val": "1.00E+02",
        "description": "Double artificial colony production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve artificial colony",
        "lol": "",
        "maxlevel": "4",
        "name": "tech12_prod",
        "requires.unittype": "tech12",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech12"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor12",
        "cost.val": "1.00E+02",
        "description": "Double artificial civilization production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech13",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve artificial civilization",
        "lol": "",
        "maxlevel": "3",
        "name": "tech13_prod",
        "requires.unittype": "tech13",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech13"
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "fame",
        "cost.val": "1.00E+17",
        "description": "Double mechanic production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech1",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Train mechanic",
        "lol": "",
        "maxlevel": "",
        "name": "tech1_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech1_prod",
        "requires.val": "15",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech1"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech1",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech1_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor1",
        "cost.val": "1.00E+16",
        "description": "Double supervisor production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Train supervisor",
        "lol": "",
        "maxlevel": "",
        "name": "tech2_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech2_prod",
        "requires.val": "14",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech2"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech2_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor2",
        "cost.val": "1.00E+15",
        "description": "Double brigade production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Train brigade",
        "lol": "",
        "maxlevel": "",
        "name": "tech3_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech3_prod",
        "requires.val": "13",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech3"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech3_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor3",
        "cost.val": "1.00E+14",
        "description": "Double technology facility production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology facility",
        "lol": "",
        "maxlevel": "",
        "name": "tech4_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech4_prod",
        "requires.val": "12",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech4"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech4_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor4",
        "cost.val": "1.00E+13",
        "description": "Double technology center production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology center",
        "lol": "",
        "maxlevel": "",
        "name": "tech5_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech5_prod",
        "requires.val": "11",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech5"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech5_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor5",
        "cost.val": "1.00E+12",
        "description": "Double technology campus production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology campus",
        "lol": "",
        "maxlevel": "",
        "name": "tech6_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech6_prod",
        "requires.val": "10",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech6"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech6_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor6",
        "cost.val": "1.00E+11",
        "description": "Double technology complex production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology complex",
        "lol": "",
        "maxlevel": "",
        "name": "tech7_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech7_prod",
        "requires.val": "9",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech7"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech7_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor7",
        "cost.val": "1.00E+10",
        "description": "Double technology cluster production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology cluster",
        "lol": "",
        "maxlevel": "",
        "name": "tech8_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech8_prod",
        "requires.val": "8",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech8"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech8_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor8",
        "cost.val": "1.00E+09",
        "description": "Double technology neuron production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Upgrade technology neuron",
        "lol": "",
        "maxlevel": "",
        "name": "tech9_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech9_prod",
        "requires.val": "7",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech9"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech9_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor9",
        "cost.val": "1.00E+08",
        "description": "Double neuron network production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve neuron network",
        "lol": "",
        "maxlevel": "",
        "name": "tech10_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech10_prod",
        "requires.val": "6",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech10"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech10_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor10",
        "cost.val": "1.00E+07",
        "description": "Double artificial intelligence production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve artificial intelligence",
        "lol": "",
        "maxlevel": "",
        "name": "tech11_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech11_prod",
        "requires.val": "5",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech11"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech11_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor11",
        "cost.val": "1.00E+06",
        "description": "Double artificial colony production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve artificial colony",
        "lol": "",
        "maxlevel": "",
        "name": "tech12_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech12_prod",
        "requires.val": "4",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech12"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech12_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "10",
        "cost.unittype": "sponsor12",
        "cost.val": "1.00E+05",
        "description": "Double artificial civilization production.",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "tech13",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Improve artificial civilization",
        "lol": "",
        "maxlevel": "",
        "name": "tech13_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "tech13_prod",
        "requires.val": "3",
        "short": "LVL UP",
        "template": "techs_upgrade.html",
        "unittype": "tech13"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "tech13",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0625",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "tech13_prod2",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "66",
        "cost.unittype": "technology",
        "cost.val": "1.00E+12",
        "description": "Increase driving multiplier with 1",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "Driving skills",
        "lol": "",
        "maxlevel": "",
        "name": "driving_upgrade",
        "requires.unittype": "technology",
        "requires.upgradetype": "",
        "requires.val": "1.00E+11",
        "short": "LVL UP",
        "template": "driving_upgrade.html",
        "unittype": "upgrade_driving"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStat",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "1",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "driving_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "upgrade_driving",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0025",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "driving_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1",
        "cost.unittype": "technology",
        "cost.val": "1.00E+17",
        "description": "Hire a racer",
        "effect.stat": "",
        "effect.type": "addUnit",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "",
        "label": "Racers",
        "lol": "",
        "maxlevel": "1",
        "name": "autoclicker_buy",
        "requires.unittype": "technology",
        "requires.upgradetype": "",
        "requires.val": "1.00E+16",
        "short": "HIRE",
        "template": "autoclicker_buy.html",
        "unittype": "autoclicker"
      },
      {
        "class": "upgrade",
        "cost.factor": "6.66E+02",
        "cost.unittype": "technology",
        "cost.val": "6.66E+19",
        "description": "Hire additional racer",
        "effect.stat": "prod2",
        "effect.type": "addStat",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "1",
        "label": "Racers",
        "lol": "",
        "maxlevel": "",
        "name": "autoclicker_upgrade",
        "requires.unittype": "autoclicker",
        "requires.upgradetype": "",
        "requires.val": "1",
        "short": "LVL UP",
        "template": "autoclicker_upgrade.html",
        "unittype": "autoclicker"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0025",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "autoclicker_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car2_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car2_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "20",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car3_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "10",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car3_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car4_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car4_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "400000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car5_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "200000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car5_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "240000000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car6_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "120000000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car6_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.20E+11",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car7_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "360000000000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car7_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.73E+16",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car8_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "8640000000000000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car8_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "5.39E+21",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car9_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2695680000000000000000",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car9_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.5324E+28",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car10_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.7662E+30",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car10_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.8691E+36",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car11_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.9346E+38",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car11_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.6412E+47",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.8206E+49",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0513E+60",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "5.2565E+61",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.6508E+74",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "8.2540E+75",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "6.0398E+90",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.0199E+92",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "8.3307E+109",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.1654E+111",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.0094E+131",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.5047E+133",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "5.8210E+156",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.9105E+158",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.7198E+184",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.8599E+186",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.6456E+216",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.3228E+218",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.7906E+251",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8953E+253",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.6742E+290",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8371E+292",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.8983E+333",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.9492E+335",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "7.3253E+380",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.6627E+382",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "3.9447E+432",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.9724E+434",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.8495E+489",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.9248E+491",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8451E+551",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.2255E+552",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "4.1959E+617",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.0980E+619",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.8742E+689",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "9.3710E+690",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "2.6606E+766",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "base",
        "effect.type": "addStatInc",
        "effect.unittype": "autoclicker",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.3303E+768",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1.00E+17",
        "cost.unittype": "technology",
        "cost.val": "5.00E+53",
        "description": "Increase sponsor production with achievement points",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor1",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "Better sponsors",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "technology",
        "requires.upgradetype": "5.00E+52",
        "requires.val": "0",
        "short": "LVL UP",
        "template": "sponsor_upgrades.html",
        "unittype": "upgrade_sponsors"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "sponsor12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "upgrade_sponsors",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.0666",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "sponsor_upgrades",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "upgrade",
        "cost.factor": "1.00E+13",
        "cost.unittype": "technology",
        "cost.val": "1.00E+21",
        "description": "Increase cars production with achievement points",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car1",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "Better cars",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "technology",
        "requires.upgradetype": "1.00E+20",
        "requires.val": "0",
        "short": "LVL UP",
        "template": "car_upgrades.html",
        "unittype": "upgrade_cars"
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car2",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car3",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car4",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car5",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car6",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car7",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car8",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car9",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car10",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car11",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car12",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car13",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car14",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car15",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car16",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car17",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car18",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car19",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car20",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car21",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car22",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car23",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car24",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car25",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car26",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car27",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car28",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car29",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "prod2",
        "effect.type": "multStatPerAchievementPoint",
        "effect.unittype": "car30",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.125",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "upgradecost",
        "effect.type": "addStatInc",
        "effect.unittype": "upgrade_cars",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "0.025",
        "effect.val2": "0",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car3_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car4_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car5_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car6_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car7_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car8_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car9_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car10_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car11_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car3_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car4_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car5_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car6_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car7_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car8_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car9_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car10_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.00009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car11_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.power",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.01",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0011",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0012",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0013",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0014",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0015",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0016",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0017",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0018",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0019",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_upgrade",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car12_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0002",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car13_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0003",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car14_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0004",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car15_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0005",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car16_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0006",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car17_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0007",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car18_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0008",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car19_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0009",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car20_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.001",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car21_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0011",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car22_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0012",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car23_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0013",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car24_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0014",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car25_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0015",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car26_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0016",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car27_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0017",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car28_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0018",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car29_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      },
      {
        "class": "",
        "cost.factor": "",
        "cost.unittype": "",
        "cost.val": "",
        "description": "",
        "effect.stat": "critical.chance",
        "effect.type": "multStat",
        "effect.unittype": "racing",
        "effect.unittype2": "",
        "effect.upgradetype": "",
        "effect.val": "1.0019",
        "effect.val2": "",
        "label": "",
        "lol": "",
        "maxlevel": "",
        "name": "car30_buy",
        "requires.unittype": "",
        "requires.upgradetype": "",
        "requires.val": "",
        "short": "",
        "template": "",
        "unittype": ""
      }
    ],
    "name": "upgrades"
  }
});